import api from '../api.js';
import * as types from '../types.js';

export default {

	html: `
		<style>
			#carrier #company_id			{ width: 10rem;		}
			#carrier #id					{ width: 5rem; text-align: right;	}
			#carrier #type					{ width: 4rem;		}
			#carrier #nick					{ width: 28rem;		}
			#carrier #name					{ width: 28rem; 	}
			#carrier #email					{ width: 20rem;		}
			#carrier #cpf					{ width: 8rem;		}
			#carrier #cnpj					{ width: 10rem; 	}
			#carrier #ie					{ width: 8rem; 		}
			#carrier #ie_type				{ width: 10rem;		}
			#carrier #phone					{ width: 10rem;		}
			#carrier #address_street		{ width: 26rem;		}
			#carrier #address_number		{ width: 6rem;		}
			#carrier #address_complement	{ width: 15rem;		}
			#carrier #address_district		{ width: 20rem;		}
			#carrier #address_state			{ width: 3.5rem;	}
			#carrier #address_city_id		{ width: 17rem;		}
			#carrier #address_zipcode		{ width: 6rem;		}
		</style>
		<form id="carrier" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="person_types">
			</datalist>
			<datalist id="ie_types">
			</datalist>
			<datalist id="states">
			</datalist>
			<datalist id="cities">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do transportador">Transp
					<input id="id" type="text" disabled>
				</label>
				<label title="Tipo de personalidade jurídica">Tipo<sup>*</sup>
					<input id="type" type="text" list="person_types" required>
				</label>
				<label title="Nome curto do transportador">Apelido<sup>*</sup>
					<input id="nick" type="text" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Nome ou razão social">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
				<label title="Email">Email
					<input id="email" type="text">
				</label>
			</div>
			<div class="fsb" id="local_delivery_row">
				<label title="Cadastro simplificado para local de entrega (ex.: departamento)">Modo local de entrega
					<input id="is_local_delivery" type="checkbox" title="Desabilita CPF, CNPJ, IE e Tipo IE; usa Tipo LOCAL">
				</label>
			</div>
			<div class="fsb">
				<label title="Telefone com DDI e DDD">Telefone
					<input id="phone" type="text" placeholder="+00 (00) 0000-0000">
				</label>
				<label title="Número do CPF">CPF
					<input id="cpf" type="text" placeholder="000.000.000-00">
				</label>
				<label title="Número do CNPJ">CNPJ
					<input id="cnpj" type="text" placeholder="00.000.000/0000-00">
				</label>
				<label title="Número da Inscrição Estadual">IE
					<input id="ie" type="text" placeholder="000.000.000.000">
				</label>
				<label title="Tipo de Inscrição Estadual">Tipo IE<sup>*</sup>
					<input id="ie_type" type="text" list="ie_types" required>
				</label>
			</div>
			<div class="fsb">
				<input type="hidden" id="address_id">
				<label title="Nome da rua ou avenida">Logradouro
					<input id="address_street" type="text">
				</label>
				<label title="Número">Número
					<input id="address_number" type="text">
				</label>
				<label title="Complemento">Complemento
					<input id="address_complement" type="text">
				</label>
			</div>
			<div class="fsb">
				<label title="Bairro">Bairro
					<input id="address_district" type="text">
				</label>
				<label title="Unidade Federativa">UF
					<input id="address_state" type="text" list="states">
				</label>
				<label title="Município">Município
					<input id="address_city_id" type="text" list="cities">
				</label>
				<label title="CEP">CEP
					<input id="address_zipcode" type="text" placeholder="00000-000">
				</label>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,

	form: 
	{
		selector: '#carrier',
		init(formset)	// Must not be async as init seq must be preserved
		{
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			Object.getPrototypeOf(this).init.call(this);
			const sel = formset.form.selector;
			const chk = document.querySelector(`${sel} #is_local_delivery`);
			const typeEl = document.querySelector(`${sel} #type`);
			const cpfEl = document.querySelector(`${sel} #cpf`);
			const cnpjEl = document.querySelector(`${sel} #cnpj`);
			const ieEl = document.querySelector(`${sel} #ie`);
			const ieTypeEl = document.querySelector(`${sel} #ie_type`);
			const toggleLocal = () => {
				if (!chk) return;
				const on = chk.checked;
				[cpfEl, cnpjEl, ieEl, ieTypeEl].forEach(el => {
					if (el) { el.disabled = on; el.required = !on; if (on) el.value = ''; }
				});
				if (typeEl) {
					if (on) { typeEl.value = 'L'; typeEl.disabled = true; }
					else typeEl.disabled = false;
				}
			};
			chk?.addEventListener('change', toggleLocal);
			formset.subscribe && formset.subscribe(['open'], () => {
				setTimeout(() => {
					if (typeEl?.value === 'L') chk.checked = true;
					toggleLocal();
				}, 0);
			});
		},
	},
	
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#type' }, types: [types.opt_person_type(), types.datalist()] },
		{ properties: { selector: '#nick' }, types: [types.name()] },
		{ properties: { selector: '#name' }, types: [types.name()] },
		{ properties: { selector: '#cpf' }, types: [types.cpf()] },
		{ properties: { selector: '#cnpj' }, types: [types.cnpj()] },
		{ properties: { selector: '#ie' }, types: [types.ie()] },
		{ properties: { selector: '#ie_type' }, types: [types.opt_ie_type(), types.datalist()] },
		{ properties: { selector: '#phone' }, types: [types.phone()] },
		{ properties: { selector: '#email' }, types: [types.email()] },
		{ properties: { selector: '#address_id' }, types: [] },
		{ properties: { selector: '#address_street' }, types: [types.name()] },
		{ properties: { selector: '#address_number' }, types: [types.name()] },
		{ properties: { selector: '#address_complement' }, types: [types.name()] },
		{ properties: { selector: '#address_district' }, types: [types.name()] },
		{ properties: { selector: '#address_state' }, types: [types.pubsub(), types.opt_uf(), types.datalist()] },
		{ properties: { selector: '#address_city_id' }, types: [types.pubsub(), types.datalist(), types.observer('address_state'), types.obs_load_options('cities', { labels: ['city'], index: 2 })] },
		{ properties: { selector: '#address_zipcode' }, types: [types.cep(), types.obs_cep()] },
		{ properties: { selector: '#is_local_delivery' }, types: [types.checkbox()] },
	]

};

